class Macrotag {

  constructor (data) {
    if (data !== undefined) {
      Object.entries(data).forEach(([key, value]) => {
        this[key] = value
      })
    }
  }

  prepareForSend () {
    return _.cloneDeep(this)
  }
}

export {
  Macrotag as default
}



// WEBPACK FOOTER //
// ./src/models/macrotag.js